<template>
  <div ref="content" class="distributor-article-list">
    <div class="common-header-wrap">
      <mt-header :title="title" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="content text" v-if="id == 1">{{ content }}</div>

    <div class="content qa" v-else-if="id == 2 || id == 3">
      <div class="list">
        <div class="title">{{ content.title }}</div>

        <div class="items" v-for="(it, inx) in content.list" :key="inx">
          <div class="item">
            <div class="question">{{ it.question }}</div>
            <div class="answer">{{ it.answer }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content" v-else v-html='content'></div>
  </div>
</template>
<script>
import { getAbout, getQA, getAboutContent, getDocumentInfo } from '../../../api/homeArticle'
import { Toast } from 'mint-ui'
export default {
  name: 'HomeDocument',
  data() {
    return {
      title: '',
      content: '',
      id: 0
    }
  },
  created: function () {
    this.id = this.$route.query.id
    let type = this.$route.query.type
    if (this.id == 1) {
      getAbout().then(res => {
        this.title = res.result.title
        this.content = res.result.content
      }).catch(function (error) {
        Toast(error.message)
      })
    } else if (this.id == 2 || this.id == 3) {
      getAboutContent(type).then(res => {
        this.title = 'Q&A'
        this.content = res.result
        this.title = this.content.title
      }).catch(function (error) {
        Toast(error.message)
      })
      // if (this.id == 3) {
      //   setTimeout(() => {
      //     this.scrollToBottom()
      //   }, 1000);
      // }
      // } else {
      // let type = this.$route.query.type
      // getDocumentInfo(type).then(res => {
      //   this.title = res.result.document_title
      //   this.content = res.result.document_content
      // }).catch(function (error) {
      //   Toast(error.message)
      // })
    }
  },
  methods: {
    isHtmlString(str) {
      // 使用正则表达式来检查是否有任何 HTML 标签
      return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const contentElement = this.$refs.content;
        if (contentElement) {
          contentElement.scrollTop = contentElement.scrollHeight;
        }
      });
    },
  }

}
</script>
<style  lang="scss" scoped>
.distributor-article-list {
  background: #fff;
  height: 100vh;
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

.content {
  padding: .5rem;
  font-size: $subFontSize;
}

.text {
  text-indent: 2em;
  line-height: 1.5;
  font-size: 0.85rem;
}

.qa {
  .list {
    margin-bottom: 1rem;

    .title {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: .5rem;
    }

    .items {
      margin-bottom: .5rem;

      .item {
        padding: .5rem;
        border-radius: .5rem;
        background: #f5f5f5;

        .question {
          font-weight: bold;
          margin-bottom: .5rem;
        }

        .answer {
          font-size: .85rem;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
